import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { useSite } from "@/context/SiteContext";
import { SmartLink } from "@/components/site/SmartLink";
import { cn } from "@/lib/utils";

const MobileMega = ({ close }) => {
  const { groups } = useSite();
  return (
    <div className="mt-2 max-h-[280px] overflow-y-auto thin-scroll rounded-lg border border-border bg-ivory p-3" data-testid="mobile-mega-box">
      {groups.filter((g) => g.schools.length).map((g) => (
        <div key={g.id} className="mb-3">
          <p className="text-[11px] font-bold uppercase tracking-wider text-brand mb-1">{g.name}</p>
          {g.schools.map((s) => (
            <Link key={s.id} to={`/school/${s.slug}`} onClick={close} className="block py-1 text-sm text-charcoal/80 hover:text-brand" data-testid={`mobile-school-${s.slug}`}>{s.name}</Link>
          ))}
        </div>
      ))}
    </div>
  );
};

const Expandable = ({ item, open, toggle, children }) => (
  <div>
    <button type="button" onClick={toggle} className="w-full flex items-center justify-between py-3 text-base font-semibold text-charcoal" data-testid={`mobile-nav-${item.id}`}>
      {item.label}
      <ChevronDown className={cn("h-4 w-4 transition-transform duration-200", open && "rotate-180")} />
    </button>
    {open && children}
  </div>
);

export const MobileMenu = ({ items }) => {
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const close = () => setOpen(false);
  const toggle = (id) => setExpanded((e) => (e === id ? null : id));
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button type="button" className="lg:hidden p-2 text-charcoal" aria-label="Open menu" data-testid="mobile-menu-button"><Menu className="h-6 w-6" /></button>
      </SheetTrigger>
      <SheetContent side="right" className="w-[88vw] max-w-sm overflow-y-auto font-arial-all" data-testid="mobile-menu-sheet">
        <SheetTitle className="text-brand text-lg mb-4">Menu</SheetTitle>
        <nav className="divide-y divide-border">
          {items.map((it) => {
            if (it.type === "mega") return <Expandable key={it.id} item={it} open={expanded === it.id} toggle={() => toggle(it.id)}><MobileMega close={close} /></Expandable>;
            if (it.type === "dropdown") {
              return (
                <Expandable key={it.id} item={it} open={expanded === it.id} toggle={() => toggle(it.id)}>
                  <div className="pb-2 pl-3">
                    {it.children.filter((c) => !c.hidden).map((c) => (
                      <SmartLink key={c.id} to={c.to} onClick={close} className="block py-2 text-sm text-charcoal/80 hover:text-brand" data-testid={`mobile-nav-${c.id}`}>{c.label}</SmartLink>
                    ))}
                  </div>
                </Expandable>
              );
            }
            return <SmartLink key={it.id} to={it.to} onClick={close} className="block py-3 text-base font-semibold text-charcoal hover:text-brand" data-testid={`mobile-nav-${it.id}`}>{it.label}</SmartLink>;
          })}
        </nav>
      </SheetContent>
    </Sheet>
  );
};
